import { StepType, MidiNote } from "../../reactronica";

export enum TrackType {
  INSTRUMENT,
  AUDIO_FILE,
}

export interface TrackProperties {
  id: number;
  name: string;
  type: TrackType;
  volume: number;
  pan: number;
  mute: boolean;
  solo: boolean;
  trackFinished?: boolean;
  duration?: number;
}

export interface InstrumentTrackProperties extends TrackProperties {
  steps: StepType[];
  instrument: InstrumentProperties;
  effects?: EffectProperties[];
}

export interface AudioFileTrackProperties extends TrackProperties {
  url?: string;
  isPlayerLoaded?: boolean;
}

interface InstrumentProperties {
  type: string;
  samples?: {
    [key in MidiNote]?: string;
  };
}

interface EffectProperties {
  type: string;
  wet?: number;
}
